(() => {
  'use strict';
  if (window.gsInsuranceLoaded) return;
  window.gsInsuranceLoaded = true;
  const VARIANT = 56470477177174;
  const ROOT = (window.Shopify?.routes?.root || '/');
  const UNIT_CENTS = 427;
  let busy = false;
  let timer;
  const money = value => new Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(value / 100);
  const widgets = () => [...document.querySelectorAll('gs-shipping-insurance')];
  const notice = message => widgets().forEach(w => { const t = w.querySelector('[data-gs-insurance-status]'); if (t) t.textContent = message; });
  async function readCart() {
    const r = await fetch(ROOT + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
    if (!r.ok) throw new Error('Impossibile leggere il carrello. Riprova.');
    return r.json();
  }
  function calculate(cart) {
    const lines = cart.items.filter(i => Number(i.variant_id) === VARIANT);
    const fee = lines.reduce((sum, i) => sum + i.final_line_price, 0);
    const goods = cart.items.filter(i => Number(i.variant_id) !== VARIANT && i.requires_shipping);
    const basis = Math.max(0, cart.total_price - fee);
    const units = goods.length && basis > 0 ? Math.ceil(basis / 50000) : 0;
    return {lines, units, basis};
  }
  async function changeInsurance(cart, quantity) {
    const updates = {};
    const lines = cart.items.filter(i => Number(i.variant_id) === VARIANT);

    if (lines.length) lines.forEach((line, index) => { updates[line.key] = index === 0 ? quantity : 0; });
    else if (quantity > 0) updates[String(VARIANT)] = quantity;
    if (!Object.keys(updates).length) return;
    const r = await fetch(ROOT + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({updates})});
    const result = await r.json();
    if (!r.ok || result.status) throw new Error(result.description || 'Non è stato possibile aggiornare l’assicurazione. Nessun ordine è stato effettuato.');
    return result;
  }
  async function sync(userChoice) {
    if (busy) return;
    busy = true;
    const inputs = widgets().flatMap(w => [...w.querySelectorAll('[data-gs-insurance-choice]')]);
    inputs.forEach(i => { i.disabled = true; });
    try {
      const cart = await readCart();
      const state = calculate(cart);
      const pickupOnly = widgets().some(w => w.dataset.pickupOnly === 'true');
      const chosen = userChoice === undefined ? state.lines.length > 0 : userChoice;
      const desired = pickupOnly || !chosen ? 0 : state.units;
      const current = state.lines.reduce((sum, i) => sum + i.quantity, 0);
      widgets().forEach(w => {
        const q = w.querySelector('[data-gs-insurance-quote]'); if (q) q.textContent = money(state.units * UNIT_CENTS);
        const checkbox = w.querySelector('[data-gs-insurance-choice]'); if (checkbox) checkbox.checked = chosen && desired > 0;
      });
      if (current !== desired || state.lines.length > 1) {
        notice('Aggiornamento dell’assicurazione…');
        await changeInsurance(cart, desired);

        window.location.assign(ROOT + 'cart');
        return false;
      }
      notice('');
      return true;
    } catch (error) {
      notice(error.message);
      if (userChoice !== undefined) inputs.forEach(i => { i.checked = !userChoice; });
      return false;
    } finally {
      busy = false;
      inputs.forEach(i => { i.disabled = false; });
    }
  }
  function scheduleSync() { clearTimeout(timer); timer = setTimeout(() => sync(), 650); }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-gs-insurance-choice]')) sync(event.target.checked);
    else if (event.target.matches('input[name="updates[]"], .quantity__input')) scheduleSync();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('submit', async event => {
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    if (!widgets().length) return;
    event.preventDefault();
    if (busy) { notice('Attendi il completamento dell’aggiornamento prima di proseguire.'); return; }
    if (await sync()) window.location.assign(ROOT + 'checkout');
  }, true);
  if (widgets().length || window.location.pathname === ROOT + 'cart') sync();
})();